import type React from 'react'
import { useThemeColors } from '@/contexts/ThemeContext'
import { commonStyles, theme } from '@/lib/theme'

interface ContainerProps {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'transparent'
  padding?: keyof typeof theme.spacing | 'none'
  className?: string
  style?: React.CSSProperties
}

/**
 * Reusable container component for consistent layout patterns.
 * Provides common background colors, padding, and layout styles.
 */
export default function Container({
  children,
  variant = 'primary',
  className = '',
  style,
}: ContainerProps) {
  const colors = useThemeColors()

  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: colors.primaryBg,
        }
      case 'secondary':
        return {
          backgroundColor: colors.secondaryBg,
        }
      case 'transparent':
        return {
          backgroundColor: 'transparent',
        }
    }
  }

  const containerStyles: React.CSSProperties = {
    ...commonStyles.fullContainer,
    fontFamily: theme.fontFamily.inherit,
    color: colors.primaryText,
    ...getVariantStyles(),
    ...style,
  }

  return (
    <div className={className} style={containerStyles}>
      {children}
    </div>
  )
}
